module.exports = __webpack_public_path__ + "img/input-text.dfcd2677.svg";